<ng-container *ngIf="results">
  showing {{ results.totalItems | number : '1.0-0' }} {{ filtered === true ? 'filtered' : '' }} {{ objectName}}
  <ng-container *ngIf="$any(results).totalUnits > 0">and {{
    $any(results).totalUnits | number : '1.0-0' }} units
    <ng-container *ngIf="$any(results).rangeUnits > 0">with {{
      $any(results).rangeUnits | number : '1.0-0' }} in date range
    </ng-container>
  </ng-container>
</ng-container>
